/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Merge_Source_Group_HelpInputs */



/**
* | output |
* | --- |
* | "The source group is used to populate the source events for translation." |
*
* @param {Translation_Merge_Source_Group_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_merge_source_group_help = /** @type {((inputs?: Translation_Merge_Source_Group_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Merge_Source_Group_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le groupe source est utilise pour remplir les evenements source pour la traduction.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Quellgruppe dient dazu, die Quellereignisse für die Übersetzung zu füllen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il gruppo sorgente viene utilizzato per popolare gli eventi sorgente per la traduzione.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группа источников используется для заполнения событий-источников для перевода.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El grupo de origen se utiliza para completar los eventos de origen para la traducción.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("源组用于填充要翻译的源事件。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ソース グループは、翻訳のソース イベントを入力するために使用されます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्रोत समूह का उपयोग अनुवाद के लिए स्रोत घटनाओं को भरने के लिए किया जाता है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O grupo de origem é usado para preencher os eventos de origem para tradução.")
	return /** @type {LocalizedString} */ ("The source group is used to populate the source events for translation.")
});